import React, {useState} from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import {IconButton} from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

const PasswordInput = ((props) => {
    const [showPass, setShowPass] = useState(false);

    return (
        <OutlinedInput {...props}
                       type={showPass ? 'text' : 'password'}
                       endAdornment={
                           <IconButton
                               onClick={() => setShowPass(!showPass)}>
                               {showPass ? <VisibilityOff/> :
                                   <VisibilityIcon/>}
                           </IconButton>
                       }
        />)
});


export default PasswordInput;